import type { Language } from "@app/constants";

interface Messages {
	currentPassword: string;
	emailLabel: string;
	error: {
		emailInvalid: string;
	};
	header: string;
	newUsername: string;
	submit: string;
	tooltip: {
		newEmail: string;
		password: string;
	};
}

type Message = {
	[key in Language]: Messages;
};

const messages: Message = {
	en: {
		currentPassword: "Password",
		emailLabel: "Email",
		error: {
			emailInvalid:
				"Email can only consist of letters, digits or these symbols: @ . + - _",
		},
		header: "Change email",
		newUsername: "New email",
		submit: "SUBMIT",
		tooltip: {
			newEmail: "Please enter a valid email address for your new email",
			password: "Please enter your current password",
		},
	},
};

export default messages;
